/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%}.kt-error-v403[_ngcontent-%COMP%]{background-position:center;background-repeat:no-repeat;background-attachment:fixed;background-size:cover}"];
export { styles as styles };
